import type { SegmentConfig } from '@/components/ui/inputs/range/input-range-segmented'

export function getCaratSegmentsConfig(
    min: number | undefined,
    max: number | undefined
): SegmentConfig {
    return [
        [min || 0, 3, 0.5],
        [3, 6, 0.75],
        [6, max || 15, 1],
    ]
}
